import Box from "ds/components/Box";
import Badge from "ds/components/Badge";
import Link from "ds/components/Link";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps } from "../types";

type IdpGroupRolesListItemNameCellProps = CellComponentProps;

const IdpGroupRolesListItemNameCell = ({ roleBinding }: IdpGroupRolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${roleBinding.role.id}`;

  return (
    <Box align="center" fullWidth gap="large">
      <Link
        analyticsPage={AnalyticsPageOrganization.OrganizationIdpGroupRoles}
        analyticsTitle="Role Name Clicked"
        analyticsProps={{
          roleName: roleBinding.role.name,
        }}
        size="small"
        variant="secondary"
        href={roleUrl}
      >
        {roleBinding.role.name}
      </Link>

      {roleBinding.role.isSystem && <Badge type="strong" variant="blue" text="SYSTEM" />}
    </Box>
  );
};

export default IdpGroupRolesListItemNameCell;
